import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Priority countries first (alphabetical), then alphabetically sorted rest
const COUNTRY_CODES = [
  // Priority countries (alphabetical: Jamaica before United States)
  { id: "+1-JM", code: "+1", country: "JM", label: "Jamaica (+1)" },
  { id: "+1-US", code: "+1", country: "US", label: "United States (+1)" },
  // Alphabetically sorted rest
  { id: "+93", code: "+93", country: "AF", label: "Afghanistan (+93)" },
  { id: "+355", code: "+355", country: "AL", label: "Albania (+355)" },
  { id: "+213", code: "+213", country: "DZ", label: "Algeria (+213)" },
  { id: "+376", code: "+376", country: "AD", label: "Andorra (+376)" },
  { id: "+244", code: "+244", country: "AO", label: "Angola (+244)" },
  { id: "+54", code: "+54", country: "AR", label: "Argentina (+54)" },
  { id: "+374", code: "+374", country: "AM", label: "Armenia (+374)" },
  { id: "+61", code: "+61", country: "AU", label: "Australia (+61)" },
  { id: "+43", code: "+43", country: "AT", label: "Austria (+43)" },
  { id: "+994", code: "+994", country: "AZ", label: "Azerbaijan (+994)" },
  { id: "+973", code: "+973", country: "BH", label: "Bahrain (+973)" },
  { id: "+880", code: "+880", country: "BD", label: "Bangladesh (+880)" },
  { id: "+1246", code: "+1246", country: "BB", label: "Barbados (+1246)" },
  { id: "+375", code: "+375", country: "BY", label: "Belarus (+375)" },
  { id: "+32", code: "+32", country: "BE", label: "Belgium (+32)" },
  { id: "+501", code: "+501", country: "BZ", label: "Belize (+501)" },
  { id: "+229", code: "+229", country: "BJ", label: "Benin (+229)" },
  { id: "+975", code: "+975", country: "BT", label: "Bhutan (+975)" },
  { id: "+591", code: "+591", country: "BO", label: "Bolivia (+591)" },
  { id: "+387", code: "+387", country: "BA", label: "Bosnia (+387)" },
  { id: "+267", code: "+267", country: "BW", label: "Botswana (+267)" },
  { id: "+55", code: "+55", country: "BR", label: "Brazil (+55)" },
  { id: "+673", code: "+673", country: "BN", label: "Brunei (+673)" },
  { id: "+359", code: "+359", country: "BG", label: "Bulgaria (+359)" },
  { id: "+855", code: "+855", country: "KH", label: "Cambodia (+855)" },
  { id: "+237", code: "+237", country: "CM", label: "Cameroon (+237)" },
  { id: "+1-CA", code: "+1", country: "CA", label: "Canada (+1)" },
  { id: "+238", code: "+238", country: "CV", label: "Cape Verde (+238)" },
  { id: "+1345", code: "+1345", country: "KY", label: "Cayman Islands (+1345)" },
  { id: "+56", code: "+56", country: "CL", label: "Chile (+56)" },
  { id: "+86", code: "+86", country: "CN", label: "China (+86)" },
  { id: "+57", code: "+57", country: "CO", label: "Colombia (+57)" },
  { id: "+506", code: "+506", country: "CR", label: "Costa Rica (+506)" },
  { id: "+385", code: "+385", country: "HR", label: "Croatia (+385)" },
  { id: "+53", code: "+53", country: "CU", label: "Cuba (+53)" },
  { id: "+357", code: "+357", country: "CY", label: "Cyprus (+357)" },
  { id: "+420", code: "+420", country: "CZ", label: "Czech Republic (+420)" },
  { id: "+45", code: "+45", country: "DK", label: "Denmark (+45)" },
  { id: "+1767", code: "+1767", country: "DM", label: "Dominica (+1767)" },
  { id: "+1809", code: "+1809", country: "DO", label: "Dominican Republic (+1809)" },
  { id: "+593", code: "+593", country: "EC", label: "Ecuador (+593)" },
  { id: "+20", code: "+20", country: "EG", label: "Egypt (+20)" },
  { id: "+503", code: "+503", country: "SV", label: "El Salvador (+503)" },
  { id: "+372", code: "+372", country: "EE", label: "Estonia (+372)" },
  { id: "+251", code: "+251", country: "ET", label: "Ethiopia (+251)" },
  { id: "+679", code: "+679", country: "FJ", label: "Fiji (+679)" },
  { id: "+358", code: "+358", country: "FI", label: "Finland (+358)" },
  { id: "+33", code: "+33", country: "FR", label: "France (+33)" },
  { id: "+995", code: "+995", country: "GE", label: "Georgia (+995)" },
  { id: "+49", code: "+49", country: "DE", label: "Germany (+49)" },
  { id: "+233", code: "+233", country: "GH", label: "Ghana (+233)" },
  { id: "+30", code: "+30", country: "GR", label: "Greece (+30)" },
  { id: "+1473", code: "+1473", country: "GD", label: "Grenada (+1473)" },
  { id: "+502", code: "+502", country: "GT", label: "Guatemala (+502)" },
  { id: "+592", code: "+592", country: "GY", label: "Guyana (+592)" },
  { id: "+509", code: "+509", country: "HT", label: "Haiti (+509)" },
  { id: "+504", code: "+504", country: "HN", label: "Honduras (+504)" },
  { id: "+852", code: "+852", country: "HK", label: "Hong Kong (+852)" },
  { id: "+36", code: "+36", country: "HU", label: "Hungary (+36)" },
  { id: "+354", code: "+354", country: "IS", label: "Iceland (+354)" },
  { id: "+91", code: "+91", country: "IN", label: "India (+91)" },
  { id: "+62", code: "+62", country: "ID", label: "Indonesia (+62)" },
  { id: "+98", code: "+98", country: "IR", label: "Iran (+98)" },
  { id: "+964", code: "+964", country: "IQ", label: "Iraq (+964)" },
  { id: "+353", code: "+353", country: "IE", label: "Ireland (+353)" },
  { id: "+972", code: "+972", country: "IL", label: "Israel (+972)" },
  { id: "+39", code: "+39", country: "IT", label: "Italy (+39)" },
  { id: "+81", code: "+81", country: "JP", label: "Japan (+81)" },
  { id: "+962", code: "+962", country: "JO", label: "Jordan (+962)" },
  { id: "+7-KZ", code: "+7", country: "KZ", label: "Kazakhstan (+7)" },
  { id: "+254", code: "+254", country: "KE", label: "Kenya (+254)" },
  { id: "+82", code: "+82", country: "KR", label: "South Korea (+82)" },
  { id: "+965", code: "+965", country: "KW", label: "Kuwait (+965)" },
  { id: "+371", code: "+371", country: "LV", label: "Latvia (+371)" },
  { id: "+961", code: "+961", country: "LB", label: "Lebanon (+961)" },
  { id: "+370", code: "+370", country: "LT", label: "Lithuania (+370)" },
  { id: "+352", code: "+352", country: "LU", label: "Luxembourg (+352)" },
  { id: "+60", code: "+60", country: "MY", label: "Malaysia (+60)" },
  { id: "+356", code: "+356", country: "MT", label: "Malta (+356)" },
  { id: "+52", code: "+52", country: "MX", label: "Mexico (+52)" },
  { id: "+377", code: "+377", country: "MC", label: "Monaco (+377)" },
  { id: "+212", code: "+212", country: "MA", label: "Morocco (+212)" },
  { id: "+95", code: "+95", country: "MM", label: "Myanmar (+95)" },
  { id: "+977", code: "+977", country: "NP", label: "Nepal (+977)" },
  { id: "+31", code: "+31", country: "NL", label: "Netherlands (+31)" },
  { id: "+64", code: "+64", country: "NZ", label: "New Zealand (+64)" },
  { id: "+505", code: "+505", country: "NI", label: "Nicaragua (+505)" },
  { id: "+234", code: "+234", country: "NG", label: "Nigeria (+234)" },
  { id: "+47", code: "+47", country: "NO", label: "Norway (+47)" },
  { id: "+968", code: "+968", country: "OM", label: "Oman (+968)" },
  { id: "+92", code: "+92", country: "PK", label: "Pakistan (+92)" },
  { id: "+507", code: "+507", country: "PA", label: "Panama (+507)" },
  { id: "+595", code: "+595", country: "PY", label: "Paraguay (+595)" },
  { id: "+51", code: "+51", country: "PE", label: "Peru (+51)" },
  { id: "+63", code: "+63", country: "PH", label: "Philippines (+63)" },
  { id: "+48", code: "+48", country: "PL", label: "Poland (+48)" },
  { id: "+351", code: "+351", country: "PT", label: "Portugal (+351)" },
  { id: "+1787", code: "+1787", country: "PR", label: "Puerto Rico (+1787)" },
  { id: "+974", code: "+974", country: "QA", label: "Qatar (+974)" },
  { id: "+40", code: "+40", country: "RO", label: "Romania (+40)" },
  { id: "+7-RU", code: "+7", country: "RU", label: "Russia (+7)" },
  { id: "+966", code: "+966", country: "SA", label: "Saudi Arabia (+966)" },
  { id: "+221", code: "+221", country: "SN", label: "Senegal (+221)" },
  { id: "+381", code: "+381", country: "RS", label: "Serbia (+381)" },
  { id: "+65", code: "+65", country: "SG", label: "Singapore (+65)" },
  { id: "+421", code: "+421", country: "SK", label: "Slovakia (+421)" },
  { id: "+386", code: "+386", country: "SI", label: "Slovenia (+386)" },
  { id: "+27", code: "+27", country: "ZA", label: "South Africa (+27)" },
  { id: "+34", code: "+34", country: "ES", label: "Spain (+34)" },
  { id: "+94", code: "+94", country: "LK", label: "Sri Lanka (+94)" },
  { id: "+1758", code: "+1758", country: "LC", label: "St. Lucia (+1758)" },
  { id: "+1784", code: "+1784", country: "VC", label: "St. Vincent (+1784)" },
  { id: "+46", code: "+46", country: "SE", label: "Sweden (+46)" },
  { id: "+41", code: "+41", country: "CH", label: "Switzerland (+41)" },
  { id: "+886", code: "+886", country: "TW", label: "Taiwan (+886)" },
  { id: "+255", code: "+255", country: "TZ", label: "Tanzania (+255)" },
  { id: "+66", code: "+66", country: "TH", label: "Thailand (+66)" },
  { id: "+1868", code: "+1868", country: "TT", label: "Trinidad & Tobago (+1868)" },
  { id: "+216", code: "+216", country: "TN", label: "Tunisia (+216)" },
  { id: "+90", code: "+90", country: "TR", label: "Turkey (+90)" },
  { id: "+256", code: "+256", country: "UG", label: "Uganda (+256)" },
  { id: "+380", code: "+380", country: "UA", label: "Ukraine (+380)" },
  { id: "+971", code: "+971", country: "AE", label: "UAE (+971)" },
  { id: "+44", code: "+44", country: "GB", label: "United Kingdom (+44)" },
  { id: "+598", code: "+598", country: "UY", label: "Uruguay (+598)" },
  { id: "+58", code: "+58", country: "VE", label: "Venezuela (+58)" },
  { id: "+84", code: "+84", country: "VN", label: "Vietnam (+84)" },
  { id: "+260", code: "+260", country: "ZM", label: "Zambia (+260)" },
  { id: "+263", code: "+263", country: "ZW", label: "Zimbabwe (+263)" },
];

interface PhoneInputProps {
  countryCode: string;
  phoneNumber: string;
  onCountryCodeChange: (code: string) => void;
  onPhoneNumberChange: (number: string) => void;
  disabled?: boolean;
  inputClassName?: string;
}

export function PhoneInput({
  countryCode,
  phoneNumber,
  onCountryCodeChange,
  onPhoneNumberChange,
  disabled = false,
  inputClassName = "",
}: PhoneInputProps) {
  // Format phone number as user types (XXX) XXX-XXXX
  const formatPhoneNumber = (value: string) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, "");
    
    // Limit to 10 digits
    const limitedDigits = digits.slice(0, 10);
    
    // Format as (XXX) XXX-XXXX
    if (limitedDigits.length === 0) return "";
    if (limitedDigits.length <= 3) return `(${limitedDigits}`;
    if (limitedDigits.length <= 6) return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3)}`;
    return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3, 6)}-${limitedDigits.slice(6)}`;
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneNumber(e.target.value);
    onPhoneNumberChange(formatted);
  };

  // Get display label for selected country using id
  const selectedCountry = COUNTRY_CODES.find((c) => c.id === countryCode);

  return (
    <div className="flex gap-2">
      <Select value={countryCode} onValueChange={onCountryCodeChange} disabled={disabled}>
        <SelectTrigger className="w-[140px] shrink-0">
          <SelectValue placeholder="Code">
            {selectedCountry ? (
              <span className="flex items-center gap-1">
                <span className="text-muted-foreground">{selectedCountry.country}</span>
                <span>{selectedCountry.code}</span>
              </span>
            ) : (
              "Code"
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[300px] bg-background">
          {COUNTRY_CODES.map((country, index) => (
            <SelectItem 
              key={country.id} 
              value={country.id}
              className={index === 2 ? "border-t mt-1 pt-2" : ""}
            >
              {country.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        placeholder="(555) 555-5555"
        value={phoneNumber}
        onChange={handlePhoneChange}
        disabled={disabled}
        className={`flex-1 ${inputClassName}`}
        maxLength={14}
      />
    </div>
  );
}

// Helper to parse stored phone into country code id and number
export function parsePhoneNumber(fullPhone: string): { countryCode: string; phoneNumber: string } {
  if (!fullPhone) return { countryCode: "+1-JM", phoneNumber: "" };
  
  // Try to match known country codes (longest first)
  const sortedCodes = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);
  
  for (const { code, id } of sortedCodes) {
    if (fullPhone.startsWith(code)) {
      const number = fullPhone.slice(code.length);
      // Format the remaining digits
      const digits = number.replace(/\D/g, "").slice(0, 10);
      let formatted = "";
      if (digits.length > 0) {
        if (digits.length <= 3) formatted = `(${digits}`;
        else if (digits.length <= 6) formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
        else formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
      }
      return { countryCode: id, phoneNumber: formatted };
    }
  }
  
  // Default to Jamaica if no match, treat whole thing as phone number
  const digits = fullPhone.replace(/\D/g, "").slice(0, 10);
  let formatted = "";
  if (digits.length > 0) {
    if (digits.length <= 3) formatted = `(${digits}`;
    else if (digits.length <= 6) formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    else formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return { countryCode: "+1-JM", phoneNumber: formatted };
}

// Helper to combine country code id and phone number for storage
export function combinePhoneNumber(countryCodeId: string, phoneNumber: string): string {
  // Find the actual code from the id (e.g., "+1-JM" -> "+1")
  const country = COUNTRY_CODES.find(c => c.id === countryCodeId);
  const actualCode = country?.code || countryCodeId.split('-')[0];
  const digits = phoneNumber.replace(/\D/g, "");
  return `${actualCode}${digits}`;
}

export { COUNTRY_CODES };
